const handleDeleteCompanyFormCompany = {
  text: 'Deseja realmente deletar essa empresa?',
  title: 'DELETAR EMPRESA',
};

export default handleDeleteCompanyFormCompany;
